import { Menu } from 'antd'
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react'
import Http from "@/utils/http";
import ConstValue from "@/utils/value";
import './index.scss'
import NavLink from '@/components/NavLink'
import { useParams } from 'react-router-dom';

export default function ProductsNew2() {
  const navigate = useNavigate()
  const [info, setInfo] = useState([]);
  const [info2, setInfo2] = useState({});

  const getParams = useParams();

  const getInfo = async () => {

    let res2 = await Http.to.items("SolutionPage/" + getParams.id).readByQuery({
      sort: ['id'],
    });
    console.log(res2);
    setInfo2(res2.data);
    let res = await Http.to.items("solutions").readByQuery({
      sort: ['sort'],
      filter: { category: res2?.data?.title, status: "published" }
    });
    setInfo(res.data)
    console.log(res.data);
  }
  const toPage = (address, routerName) => {
    if (address.indexOf('http') !== -1) {
      window.open(address);
      return
    }
    navigate('/' + address);
  }
  useEffect(() => {
    getInfo()
  }, [])
  return (
    <div className='products_new2'>
      <NavLink title1={'Products · Solution'} link1={() => { toPage('Solution') }} title2={info2.title} />
      <div className='top_bg' >
        <div className='bg' style={{ backgroundImage: `url(${ConstValue.url + "assets/" + info2?.backgroundimg})` }}></div>
        <div className='top_bg_content'>
          <div className='left'>
            <div className='left_content'>
              <div className='title'>{info2.title}</div>
              <div className='info'>{info2.content}</div>
            </div>
          </div>
          <div className='right'>
            <div className='img_r' style={{ backgroundImage: `url(${ConstValue.url + "assets/" + info2?.img})` }}></div>
          </div>
        </div>
      </div>
      <div className='items_container'>
        <div className='items'>
          {info.length !== 0 && info.map((item, index) => {
            return (
              <div key={index} className='item' onClick={() => {
                toPage('solutionPage2/' + item.category + '/' + item?.title)
              }}>
                <div className='item_left'>
                  <div className='title'><span>{item.title}</span></div>
                  <div className='img' style={{ backgroundImage: `url(${ConstValue.url + "assets/" + item?.img})` }}><div className='mask'></div></div>
                </div>
                <div className='item_right'>
                  <div className='info' ><span>{item?.Introduction}</span></div>
                  <div className='bottom_direction'></div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}